import {
  alteryx_header_icon,
  alteryx_header_logo,
} from "../assets/images/index";
import { AlteryxLogo } from "../assets/images/svg";
const alteryxConfig = {
  name: "alteryx",
  apiUrl: "https://woolly-lab-api-production.stage.eugeniuses.com/api/",
  image: alteryx_header_logo,
  modelId: 5,
  title: "Alteryx - Customize Your Wallet",
  description: "alteryx description",
  shopifyStoreName: "woollymade.com",
  shopifyAccessToken: "cb05b95d892493bc52b8d28d402cc83c",
  shopifyProductHalfWallet: "",
  shopifyProductKeychain: "",
  shopifyProductFullWallet: "",
  shopifyProductStickOnWallet: "",
  shopifyProductHalfWalletAlteryx: 6969040633969,
  headerContent: `HANDCRAFTED BY WOOLLY MADE<Image className='img cursor-pointer' draggable='false'  src='${alteryx_header_icon}'/>`,
  headerColor: "alteryx-header-color",
  btnClasses: "alteryx-btn",
  mainStepLogo: <AlteryxLogo />,
  footerClasses: "alteryx-footer-icon",
  dotClasses: "alteryx-dot",
  doneBtnClass: "btn-outline-alteryx",
  userName: "Alteryx",
  password: "7bJK0#P1RDsa",
  LeaveLink: "https://woollymade.com",
  sendgridApiKey:
    "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",
    apiKey: "AIzaSyA74fFrPQCiiVAQYjMxBYo3ynR941AZve0",
    sheetId: "1hvtNpagXE3z5AI85I-PkpJqnLX4RVAQKZC2vuyt8FB0",
};

export default alteryxConfig;
